import React from 'react';
import { TableColumn } from 'components/Table/Table.types';
import lodash from 'lodash';
import { formatDates } from 'utils/date';

import { TableBody as TableBodyMUI, TableCell, TableRow } from '@mui/material';

interface TableBodyProps {
  columns: TableColumn[];
  data: any[];
}

class TableBody extends React.Component<TableBodyProps> {
  renderCell = (item: any, column: TableColumn) => {
    // if column is custom
    if (column.content) return column.content(item);

    // if column is array of string
    if (column.path && lodash.isArray(lodash.get(item, column.path))) {
      let bulletList = '';
      lodash.get(item, column.path).map((i: any) => {
        if (lodash(i).startsWith('-')) {
          return (bulletList += `<p>${i}</p>`);
        }
        if (column.path?.toLowerCase().includes('date')) {
          return (bulletList += `${i} - `);
        }
        return (bulletList += `${i}, `);
      });
      return (
        <div
          // remove last , or - from the string
          dangerouslySetInnerHTML={{ __html: bulletList.slice(0, -2) }}
        ></div>
      );
    }

    // if column is object - unknown
    if (column.path && lodash.isObject(lodash.get(item, column.path))) {
      // if object is dates
      if (column.path === 'dates') {
        const { start, end } = lodash.get(item, column.path);
        const { formattedStartDate, formattedEndDate } = formatDates(
          start,
          end
        );
        return `${formattedStartDate} - ${formattedEndDate}`;
      }

      return lodash.get(item, column.path).toString();
    }

    // otherwise
    return lodash.get(item, column.path as string);
  };

  createKey(item: any, column: TableColumn) {
    return `${item.id + (column.path || column.key)}`;
  }

  render() {
    const { columns, data } = this.props;

    return (
      <TableBodyMUI>
        {data.map((item) => (
          <TableRow key={item.id}>
            {columns.map((column) => (
              <TableCell key={this.createKey(item, column)}>
                {this.renderCell(item, column)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBodyMUI>
    );
  }
}

export default TableBody;
